import React from "react";
import styled from "styled-components";
import { colors } from "utils";

// Shared banner for the change-focus views (lesson + standard): a row of assigned
// group-code pills above a "Current Lesson/Standard:" line. Matches Figma 3456-23347.
const Bar = styled.div`
  padding: 16px 32px;
  border-bottom: 1px solid ${colors.milkGlass500};
  background-color: white;
`;

const CodesRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

const CodesLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.nightlyWoods900};
  margin-right: 4px;
`;

const Chip = styled.span`
  background-color: ${colors.nightlyWoods900};
  color: white;
  border-radius: 100px;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const CurrentLine = styled.div`
  font-size: 14px;
  color: ${colors.nightlyWoods900};

  strong {
    font-weight: 700;
  }
`;

export const AssignedCodesBanner = ({ groupCodes = [], label, value }) => (
  <Bar>
    <CodesRow>
      <CodesLabel>Assigned Group Codes:</CodesLabel>
      {groupCodes.map((code) => (
        <Chip key={code}>{code?.toUpperCase()}</Chip>
      ))}
    </CodesRow>
    {(label || value) && (
      <CurrentLine>
        <strong>{label}:</strong> {value}
      </CurrentLine>
    )}
  </Bar>
);
